module.exports = __webpack_public_path__ + "img/el_avatar.f0c4de61.jpeg";